/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: false, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Yuan Tsai",
  title: "Hi, I'm Dr. Yuan",
  sequence: [
    "A passionate Digital Consultant", 2000,
    // "A passionate Software Developer ", 2000,
    "A passionate Cloud Developer ", 2000,
  ],
  //🎇🚀🏗️
  subTitle: emoji(
    " with cross-disciplinary background in both Computer-Aided Engineering and Construction Management. Primary focuses on information management, visualisation, and system integration."
  ),
  //test
  resumeLink: require('./assets/files/cv-yuan.pdf'), // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/yuantsai1115",
  linkedin: "https://www.linkedin.com/in/yuan-tsai-19888b196/",
  gmail: "yuan.tsai1115@gmail.com",
  //gitlab: "https://gitlab.com/saadpasta",
  //facebook: "https://www.facebook.com/saad.pasta7",
  //medium: "https://medium.com/@saadpasta",
  //stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Curtin University",
      logo: require("./assets/images/curtin.png"),
      subHeader: "Ph.D. of Construction Management",
      duration: "2018 - 2021",
      desc: "Participated in the research of industry-academic cooperation.",
      descBullets: [
        "3 years scholarship granted",
        "2 projects of industry-academic cooperation",
        "1 hot journal paper ranked by ESI database",
        "Joint Ph.D. program"
      ]
    },
    {
      schoolName: "National Taiwan University",
      logo: require("./assets/images/NTU.png"),
      subHeader: "Ph.D. of Computer-Aided Engineering",
      duration: "2015 - 2022",
      desc: "Participated in the research of industry-academic cooperation.",
      descBullets: [
        "5 conference papers published",
        "4 massive open online courses released",
        "3 years scholarhip granted",
        "2 textbooks published",
        "1 journal paper published",
        "Joint Ph.D. program"
      ]
    }
  ]
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Full Stack Developer",
      company: "Ecocentric",
      companylogo: require("./assets/images/ecocentric-logo.jpeg"),
      date: "Oct. 2023 – Present",
      desc: "Numen AI, a high-resolution energy monitoring system that provides actionable insights to improve safety, reduce energy consumption and optimise overall efficiency for commercial buildings.",
      descBullets: [
        "Managed electric data pipeline generating gigabytes of data every 10 minutes serving energy monitoring across 5 countries",
        "Developed weather data pipeline with two weather sources to compliment electric data",
        "Improved reliability of the data pipelines with self-healing, backfill, monitoring capabilities"
      ]
    },
    {
      role: "Digital Engineer",
      company: "SugoiiTech",
      companylogo: require("./assets/images/sugoiitech.jpg"),
      date: "Nov. 2021 – May 2023",
      desc: "A digital consultant company specialising in digital transformation, custom system development, engineering software automation in the civil engineering industry.",
      descBullets: [
        "Designed digital solutions improving the workflow for construction inspection",
        "Developed a production monitoring system that analyses cost of orders",
        "Established asset management and data visualisation solutions for airport facility management"
      ]
    },
    {
      role: "Full Stack Developer",
      company: "Transformosa",
      companylogo: require("./assets/images/bimU.png"),
      date: "Nov. 2016 – Oct. 2021",
      desc: "bimU Agile, a cloud-based and data-driven platform for virtual design and construction review in the AEC industry.",
      descBullets: [
        "Developed frontend, and desktop launcher for BIM collaboration platform",
        "Improved data query performance for building objects by 10% with Parquet format",
        "Worked with clients to discover root causes of inefficiencies in the workflows and delivered solutions on a fortnightly basis"
      ]
    }
  ]
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      // video: require(),
      image: require("./assets/images/numenAI.png"),
      projectName: "Numen AI",
      projectDesc: "A high-resolution energy monitoring system providing actionable insights to improve safety, reduce energy consumption and optimise efficiency",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://numen.ai/numen-system/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      // video: require("./assets/videos/bimU-Agile.mp4"),
      image: require("./assets/images/bimU-Agile.png"),
      projectName: "bimU Agile",
      projectDesc: "Cloud-based and data-driven BIM platform connecting BIM data with design review workflow seamlessly and coherently",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://bimu.io/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      // video: require("./assets/videos/bimU-Viewer.mp4"),
      image: require("./assets/images/bimU-Viewer.png"),
      projectName: "bimU Viewer",
      projectDesc: "A full-fledged online BIM model viewer that truly works for every project member",
      footerLink: [
        {
          name: "Try It Out",
          url: "https://viewer.bimu.io/share/models/61f78776dc2a32000401af00"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      // video: require("./assets/videos/IoT-BIM.mp4"),
      image: require("./assets/images/IoT-BIM.png"),
      projectName: "Asset management by IoT and BIM",
      projectDesc: "A web app for realtime sensor data visualising in building information models",
    },
    {
      // video: require("./assets/videos/Object detection.mp4"),
      image: require("./assets/images/Object detection.jpg"),
      projectName: "Object detection and labeling on construction site",
      projectDesc: "An iOS App for object detection and labeling on constrution site",
    },
    {
      // video: require("./assets/videos/Corrosion prediction.mp4"),
      image: require("./assets/images/Corrosion prediction.jpg"),
      projectName: "Corrosion prediction integrated with IoT and BIM",
      projectDesc: "An addin for corrosion prediction integrated theoretical corrosion model, IoT, and BIM",
    },
    {
      // video: require("./assets/videos/Estimation.mp4"),
      image: require("./assets/images/Estimation.jpg"),
      projectName: "Labour and cost estimation for coating and blasting factory",
      projectDesc: "A desktop app for labour and cost estimation in coating and blasting business",
    },
    // {
    //   image: require("./assets/images/saayaHealthLogo.webp"),
    //   projectName: "Saayahealth",
    //   projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "http://saayahealth.com/"
    //     }
    //     //  you can add extra buttons here.
    //   ]
    // },
    // {
    //   image: require("./assets/images/nextuLogo.webp"),
    //   projectName: "Nextu",
    //   projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "http://nextu.se/"
    //     }
    //   ]
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "ENTHUSIASTIC SOFTWARE DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji("⚡ Develop highly interactive User Interfaces for desktop, web, and mobile applications"),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji("⚡ Integration of third party services or APIs from software vendors")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "C#",
      fontAwesomeClassname: "fas fa-microsoft"
    },
    {
      skillName: ".NET",
      fontAwesomeClassname: "fas fa-microsoft"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },

    // {
    //   skillName: "swift",
    //   fontAwesomeClassname: "fab fa-swift"
    // },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "MySQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "MSSQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    // {
    //   skillName: "python",
    //   fontAwesomeClassname: "fab fa-python"
    // },
    // {
    //   skillName: "docker",
    //   fontAwesomeClassname: "fab fa-docker"
    // }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: emoji("⚡ Agile / Domain Driven Design / Test Driven Development / Behaviour Driven Development"), //Insert stack or technology you have experience in
      //progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: emoji("⚡ Git / C# / PowerShell / Javascript / Typescript / HTML / Css"),
      //progressPercentage: "70%"
    },
    {
      Stack: emoji("⚡ Visual Studio / Visual Studio Code / Postman / SourceTree / JSFiddle / SQL Server Management Studio / MongoDB Compass"),
      //progressPercentage: "70%"
    },
    {
      Stack: emoji("⚡ RESTful API / SOAP / WCF"),
      //progressPercentage: "60%"
    },
    {
      Stack: emoji("⚡ MySQL / MSSQL / MongoDB / S3 / GraphQL"),
      //progressPercentage: "60%"
    },
    {
      Stack: emoji("⚡ .NET / React / Node.js / ExpressJS / React Native"),
      //progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: true, // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me 📨"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  //number: "+92-0000000000",
  email_address: "yuan.tsai1115@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
